import React, { useCallback, useMemo, useRef } from 'react'

import JowRecipeCard from '../JowRecipeCard'
import UserGeneratedRecipeCard from '../UserGeneratedRecipeCard'
import usePersistElementScrollPosition from '../../hooks/usePersistElementScrollPosition'

const RecipeCard = ({
  addedToMenu,
  author,
  backgroundColor,
  backgroundPattern,
  children,
  className,
  coversCount,
  description,
  direction,
  href,
  id,
  imageUrl,
  isCooked,
  isLoading,
  isRecipeAuthor,
  missingIngredients,
  oldRecipeId,
  onAnimationEnd,
  onAnimationStart,
  onClick,
  openModal,
  placeHolderUrl,
  prefetch,
  preview,
  pricePerPortionTag,
  roundedCoversCount,
  showError,
  slug,
  source,
  style,
  tagsEdito,
  target,
  thumbnailOverlayChildren,
  title,
  unitName,
  variant,
}) => {
  const ref = useRef()
  const { persistScrollPosition } = usePersistElementScrollPosition({
    id,
    ref,
    deactivated: variant === 'embed',
  })

  const filteredPricePerPortionTag = useMemo(() => {
    return pricePerPortionTag?.level === 1 ? pricePerPortionTag : undefined
  }, [pricePerPortionTag])

  const handleClick = useCallback(
    (event) => {
      if (variant !== 'embed') {
        persistScrollPosition()
      }
      if (onClick) {
        onClick(event)
      }
    },
    [onClick, persistScrollPosition, variant],
  )

  return source === 'user-generated' ? (
    <UserGeneratedRecipeCard
      ref={ref}
      addedToMenu={addedToMenu}
      author={author}
      backgroundColor={backgroundColor}
      backgroundPattern={backgroundPattern}
      className={className}
      coversCount={coversCount}
      description={description}
      direction={direction}
      href={href}
      id={id}
      imageUrl={imageUrl}
      isCooked={isCooked}
      isLoading={isLoading}
      isRecipeAuthor={isRecipeAuthor}
      missingIngredients={missingIngredients}
      oldRecipeId={oldRecipeId}
      onAnimationEnd={onAnimationEnd}
      onAnimationStart={onAnimationStart}
      onClick={handleClick}
      openModal={openModal}
      placeHolderUrl={placeHolderUrl}
      prefetch={prefetch}
      preview={preview}
      pricePerPortionTag={filteredPricePerPortionTag}
      roundedCoversCount={roundedCoversCount}
      showError={showError}
      style={style}
      tagsEdito={tagsEdito}
      target={target}
      thumbnailOverlayChildren={thumbnailOverlayChildren}
      title={title}
      unitName={unitName}
      variant={variant}
    >
      {children}
    </UserGeneratedRecipeCard>
  ) : (
    <JowRecipeCard
      ref={ref}
      addedToMenu={addedToMenu}
      backgroundColor={backgroundColor}
      className={className}
      coversCount={coversCount}
      description={description}
      direction={direction}
      href={href}
      id={id}
      imageUrl={imageUrl}
      isCooked={isCooked}
      isLoading={isLoading}
      missingIngredients={missingIngredients}
      oldRecipeId={oldRecipeId}
      onAnimationEnd={onAnimationEnd}
      onAnimationStart={onAnimationStart}
      onClick={handleClick}
      openModal={openModal}
      prefetch={prefetch}
      preview={preview}
      pricePerPortionTag={filteredPricePerPortionTag}
      roundedCoversCount={roundedCoversCount}
      showError={showError}
      slug={slug}
      style={style}
      tagsEdito={tagsEdito}
      target={target}
      title={title}
      unitName={unitName}
      variant={variant}
    >
      {children}
    </JowRecipeCard>
  )
}

RecipeCard.defaultProps = {
  source: 'jow',
}

export default RecipeCard
